<template>
  <v-row>
    <v-col cols="12" v-if="$store.state.subscriptions.retrieveLoader">
      <v-boilerplate type="table-heading, list-item-two-line" />
      <v-skeleton-loader class="mt-5" transition="fade-transition" type="table" />
    </v-col>
    <v-col cols="12" v-else>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <v-row align="center" justify="start" no-gutters>
              <router-link :to="{name: 'AddonListCreate'}" class="subtitle-1 routerLink font-weight-medium">Complementos</router-link>
              <v-icon class="mx-1 pt-1" color="secondary">mdi-chevron-right</v-icon>
              <span class="subtitle-1 font-weight-medium d-inline-block text-truncate" :style="$vuetify.breakpoint.width < 1200 ? 'max-width: 200px;' : 'max-width: 500px;'">{{instance.name}}</span>
            </v-row>
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn class="mr-1" @click="dialogAddon=true" outlined retain-focus-on-click color="secondary">Editar</v-btn>
              <v-menu close-on-click close-on-content-click left offset-y :nudge-bottom="10" transition="slide-y-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ml-2" v-bind="attrs" v-on="on" min-width="34" max-width="34" color="secondary" outlined retain-focus-on-click><v-icon color="secondary">mdi-dots-horizontal</v-icon></v-btn>
                </template>
                <v-list class="pa-0">
                  <v-list-item class="px-5 py-1" @click="deleteAddon">
                    <v-list-item-title class="subtitle-2 red--text font-weight-medium">Eliminar complemento</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0 background">
          <v-row>
            <v-col cols="6">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title>Nombre</v-list-item-title>
                  <v-list-item-subtitle>{{instance.name}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Descripción</v-list-item-title>
                  <v-list-item-subtitle>{{instance.description}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Etiqueta de unidad</v-list-item-title>
                  <v-list-item-subtitle v-if="instance.unit_label">{{instance.unit_label}}</v-list-item-subtitle>
                  <v-list-item-subtitle class="font-italic text--disabled" v-else>Sin etiqueta de unidad</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Código</v-list-item-title>
                  <v-list-item-subtitle v-if="instance.sku">{{instance.sku}}</v-list-item-subtitle>
                  <v-list-item-subtitle class="font-italic text--disabled" v-else>Sin código</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>ID</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-tooltip right transition="scale-transition">
                      <template v-slot:activator="{on}">
                        <v-btn class="font-weight-regular" @click="toClipboard(instance.id)" text color="secondary" v-on="on" :ripple="false">{{instance.id}}</v-btn>
                      </template>
                      <span>Copiar</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Creado el</v-list-item-title>
                  <v-list-item-subtitle>{{instance.created | dateTime}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Actualizado el</v-list-item-title>
                  <v-list-item-subtitle>{{instance.updated | dateTime}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="6">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title>Precio</v-list-item-title>
                  <v-list-item-subtitle>{{instance.amount | currency(activeCurrency.id)}} {{activeCurrency.id}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Tipo de cargo</v-list-item-title>
                  <v-list-item-subtitle>{{instance.apply_scheme === 'recurring' ? `Recurrente por ${instance.duration_times} ciclos de facturación` : 'Una vez'}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- subscription list -->
      <v-card class="mt-3">
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Suscripciones activas</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0">
          <subscription-list :show-sort="false" :show-pagination="false" :show-criteria="{addons__addon__id: instance.id}"/>
        </v-card-text>
      </v-card>
      <!-- end subscription list -->
    </v-col>

    <!-- dialog addon update -->
    <v-dialog v-model="dialogAddon" width="600" persistent no-click-animation scrollable>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Editar complemento</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-1">
                <v-btn class="ml-3" @click="dialogAddon=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-list class="v-list-form py-6 transparent">
            <v-list-item class="py-1">
              <v-list-item-title>Nombre</v-list-item-title>
              <v-list-item-subtitle>
                 <v-text-field v-model.trim="$v.editable.name.$model" :error="$v.editable.name.$error" background-color="white" outlined required single-line dense maxlength="56" placeholder="Escribe un nombre" hide-details/>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-1">
              <v-list-item-title>Descripción</v-list-item-title>
              <v-list-item-subtitle>
                 <v-text-field v-model.trim="$v.editable.description.$model" :error="$v.editable.description.$error" background-color="white" outlined required single-line dense maxlength="256" placeholder="Escribe un descripción" hide-details/>
              </v-list-item-subtitle>
            </v-list-item>

            <!-- more options -->
            <v-list-item class="mt-6">
              <v-list-item-title>
                <span class="text--secondary font-weight-medium">Otras opciones</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item class="my-3">
              <v-list-item-title>Código</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="6">
                  <v-text-field id="it-plan-sku" v-model.trim="$v.editable.sku.$model" :error="$v.editable.sku.$error" background-color="white" outlined required single-line dense maxlength="32" persistent-hint hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="my-3">
              <v-list-item-title>Unidad</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="6">
                  <v-text-field id="it-plan-unit_label" v-model.trim="$v.editable.unit_label.$model" :error="$v.editable.unit_label.$error" background-color="white" placeholder="Etiqueta de unidad" outlined required single-line dense maxlength="4" persistent-hint hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <!-- end more options -->
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="dialogAddon=false" outlined color="secondary">Cancelar</v-btn>
          <v-btn @click="updateAddon" :loading="$store.state.subscriptions.createLoader" color="primary">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog addon update -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, maxLength } from 'vuelidate/lib/validators'
import SubscriptionList from '@/components/subscription/SubscriptionList'
import GenericViewMixin from '@/mixins/GenericViewMixin'
export default {
  mixins: [
    GenericViewMixin
  ],
  inject: ['theme'],
  components: {
    SubscriptionList,
    VBoilerplate: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          props: {
            boilerplate: true,
            elevation: 2,
            ...props
          }
        }, children)
      }
    }
  },
  data: () => ({
    activeCurrency: {},
    editable: {
      name: '',
      description: '',
      sku: null,
      unit_label: null
    },
    subscriptions: [],
    dialogAddon: false
  }),
  computed: mapState({
    instance: state => state.subscriptions.addonsDetail,
    subscriptionsCount: state => state.subscriptions.subscriptionsCount,
    subscriptionsList: state => state.subscriptions.subscriptionsList
  }),
  created () {
    this.$store.dispatch('subscriptions/RETRIEVE', {
      resource: 'addons',
      id: this.$route.params.id
    })
    .then(() => {
      /**
       * Initialize and assign editable fields
       */
      Object.keys(this.editable).forEach(attr => {
        this.editable[attr] = this.instance[attr]
      })
    })
    .then(() => {
      this.activeCurrency = this.currencies.find(c => c.id === this.instance.currency.id)
    })
    .then(() => {
      this.$store.dispatch('subscriptions/LIST', {
        resource: 'subscriptions',
        query: {
          addons__addon__id: this.$route.params.id,
          page_size: 6
        }
      })
    })
  },
  methods: {
    updateAddon () {
      this.$v.editable.$touch()

      if (this.$v.editable.$invalid) {
        return false
      }

      this.$store.dispatch('subscriptions/UPDATE', {
        resource: 'addons',
        id: this.instance.id,
        payload: this.editable
      })
      .then(() => {
        this.dialogAddon = false
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    deleteAddon () {
      this.$dialog.warning({
        title: 'Eliminar complemento',
        text: `
          <span class="d-block mb-4">Al eliminar este complemento, no podrás asociarlo a nuevas suscripciones. Las suscripciones activas no serán afectadas y se seguirán facturando hasta que se cancelen.</span>
          <span class="d-block my-4">¿Estás seguro de continuar?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('subscriptions/DESTROY', {
                resource: 'addons',
                id: this.instance.id
              })
              .then(() => {
                this.$router.push({
                  name: 'AddonListCreate',
                  params: {
                    id: this.instance.id
                  }
                })
                this.$dialog.message.info('El complemento ha sido eliminado')
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    }
  },
  validations: {
    editable: {
      name: {
        required,
        maxLength: maxLength(56)
      },
      description: {
        required,
        maxLength: maxLength(256)
      },
      sku: {
        maxLength: maxLength(32)
      },
      unit_label: {
        maxLength: maxLength(4)
      }
    }
  }
}
</script>